import { useEffect } from 'react';
import { useTheme } from 'styled-components';

import { usePayment } from '../../Contexts/PaymentProvider';
import { useConfig } from '../../Contexts/ConfigContext';

import { CUSTOMER_TYPE } from '../../Contexts/PaymentProvider/PaymentProvider.d';
import { FormControlLabel, RadioGroup, Radio, makeStyles, BoxProps } from '@material-ui/core';
import { Box, Text } from '@skooldio/paas-shared-react-components';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { matchesSKURules } from '../../Utils/matchesEnableCriteria';

const useStyles = (): ClassNameMap<'radio'> => {
  const theme = useTheme();
  const classes = makeStyles({
    radio: {
      '&&': { color: theme.colors.primary[500] },
    },
  })();

  return classes;
};

const PaymentType = (props: BoxProps) => {
  const { enablePurchaseAsCorporate, payment } = useConfig();
  const { skuCode, customerType, updateCustomerType, updateTaxInvoiceRequested } = usePayment();
  const classes = useStyles();

  const showIndividual = !matchesSKURules(payment?.skuPageRules, skuCode);
  const showCorporate = true;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!showIndividual) updateCustomerType(CUSTOMER_TYPE.CORPORATE);
  }, [showIndividual]);

  if (!enablePurchaseAsCorporate) return null;
  if (!showIndividual && !showCorporate) return null;

  return (
    <Box {...props}>
      <Text textStyle="subtitle1">ประเภท</Text>
      <RadioGroup
        row
        value={customerType}
        onChange={(e) => {
          updateTaxInvoiceRequested(false);
          updateCustomerType(e.target.value as CUSTOMER_TYPE);
        }}
      >
        {showIndividual && (
          <FormControlLabel
            value={CUSTOMER_TYPE.INDIVIDUAL}
            control={<Radio classes={{ checked: classes.radio }} />}
            label={
              <Text textStyle="body2" color="text.darkText">
                บุคคลทั่วไป
              </Text>
            }
          />
        )}
        {showIndividual && showCorporate && <Box ml={5} />}
        {showCorporate && (
          <FormControlLabel
            value={CUSTOMER_TYPE.CORPORATE}
            control={<Radio classes={{ checked: classes.radio }} />}
            label={
              <Text textStyle="body2" color="text.darkText">
                นิติบุคคล/บริษัท
              </Text>
            }
          />
        )}
      </RadioGroup>
    </Box>
  );
};

export default PaymentType;
